import { Box, Stack } from "@mui/material"
import { If } from "lib/@components/if"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { SeedSource } from "authoring/lib/enum/seed-source.mjs"
import { AmendsBoundaryButton } from "authoring/routes/project/amends/components/amends-boundary-button"
import { AmendsBoundaryEditor } from "authoring/routes/project/amends/components/amends-boundary-editor"
import { UnitOfMeasureSelect } from "authoring/routes/project/components/unit-of-measure-select"
import { UNIT_OF_MEASURE_AMENDS_KEY } from "../../amends/lib/constants/amends-keys"
import { useScheduleEditorSeed } from "../hooks/use-schedule-editor-seed"
import { ScheduleEditorLegacyScheduleTypes } from "./schedule-editor-legacy-schedule-types"
import { ScheduleEditorLegacyScheduleGroups } from "./schedule-editor-legacy-schedule-groups"

export function NewScheduleMetadataFields() {
    const { editMode, amendsContext } = useBoundContext()
    const { seedSource } = useScheduleEditorSeed()
    const isNewSchedule = seedSource === SeedSource.NEW

    return (
        <>
            <If truthy={!!isNewSchedule}>
                <Box mb={2}>
                    <ScheduleEditorLegacyScheduleTypes />
                </Box>
                <Box mb={2}>
                    <ScheduleEditorLegacyScheduleGroups />
                </Box>
            </If>
            <Stack direction="row" alignItems="center" spacing={1} mb={2} data-cy="schedule-uom-amends-row">
                <Box flex={1}>
                    <UnitOfMeasureSelect sx={{ mt: 0 }} disabled={!editMode} />
                </Box>
                <If truthy={!!amendsContext}>
                    <AmendsBoundaryButton amendsKey={UNIT_OF_MEASURE_AMENDS_KEY} />
                </If>
            </Stack>
            <If truthy={!!amendsContext}>
                <AmendsBoundaryEditor
                    amendsKey={UNIT_OF_MEASURE_AMENDS_KEY}
                    subtitle="Change Unit of Measure Reason"
                    data-cy="schedule-uom-amends"
                />
            </If>
        </>
    )
}
